import { render, staticRenderFns } from "./DesignCalendarDetail.vue?vue&type=template&id=385660ce"
import script from "./DesignCalendarDetail.vue?vue&type=script&lang=js"
export * from "./DesignCalendarDetail.vue?vue&type=script&lang=js"
import style0 from "./DesignCalendarDetail.vue?vue&type=style&index=0&id=385660ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports